import React, { act, useEffect, useState } from "react";
import img8 from "../../../Assets/propertydetails/dustbin.svg";
import img9 from "../../../Assets/propertydetails/deposite.svg";
import img10 from "../../../Assets/propertydetails/backgroundImage.png";
import Aos from "aos";
import "aos/dist/aos.css";
import { AirVent, Car, Sofa, Tv, Wifi } from "lucide-react";
import { RiFridgeFill } from "react-icons/ri";
import { GiWashingMachine } from "react-icons/gi";
import { IoCarSport } from "react-icons/io5";
import { MdDirectionsBike, MdTempleBuddhist } from "react-icons/md";
import axios from "axios";
import toast from "react-hot-toast";

const HostelInfo = ({ building }) => {
  const [activeTab, setActiveTab] = useState("Visit");
  const [form, setForm] = useState({
    name: "",
    phone: "",
    location: "",
    type: activeTab,
  });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    Aos.init({
      duration: 1000, // Animation duration
      easing: "ease-in-out", // Animation easing
      once: true, // Animation happens only once when scrolled into view
    });
  }, []);

  const handleSubmit = () => {
    setLoading(true);

    if (!form.name || !form.phone) {
      return toast.error("Name and Phone number are required");
    }

    let config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/lead/create-lead`,
      maxBodyLength: Infinity,
      data: form,
    };

    axios
      .request(config)
      .then((response) => {
        // console.log("Response of handleSubmit(Lead): ", response.data);
        setLoading(false);
        setForm({
          name: "",
          phone: "",
          location: "",
        });
        toast.success(
          "Your query has been recorded. We'll reach you out soon."
        );
      })
      .catch((error) => {
        // console.log("Error in handleSubmit: ", error);
        setLoading(false);
        toast.error("Something went wrong. Please try again later.");
      });
  };
  return (
    <div className="px-6 py-10 sm:px-16">
      {/* Title and Location */}
      <div
        className="grid lg:grid-cols-2 grid-cols-1 gap-5"
        data-aos="fade-right"
      >
        <div>
          {" "}
          <h1 className="text-3xl font-bold text-gray-900">
            {building?.nameBuilding}
          </h1>
          <p className="text-lg text-gray-600">
            {building?.pgAddress}, {building?.city}, {building?.state}
          </p>
          {/* Price Section */}
          <div className="mt-4 flex items-center">
            <span className="bg-blue-600 text-white px-4 py-2 rounded text-lg font-semibold">
              Starts at - ₹{building.startingPrice || 10000}
            </span>
            <span className="text-red-600 font-semibold text-lg ml-2">
              / Monthly
            </span>
          </div>
          {/* Overview Section */}
          <h2 className="text-2xl font-semibold text-gray-900 mt-6">
            Overview
          </h2>
          <p className="text-gray-600 mt-2">{building.overview}</p>
          {/* Free Amenities Section */}
          <h2 className="text-2xl font-semibold text-gray-900 mt-6">
            Free Amenities
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-4 text-gray-700">
            {building?.amenities?.airConditioner && (
              <div className="flex flex-col items-center">
                <div>
                  <AirVent size={24} className="text-gray-400" />
                </div>
                <div>
                  <h1 className="text-sm text-center">Air Conditioner</h1>
                </div>
              </div>
            )}

            {building?.amenities?.commonLoungeArea && (
              <div className="flex flex-col items-center ">
                <div>
                  <Tv size={24} className="text-gray-400" />
                </div>
                <div>
                  <h1 className="text-sm text-center">Common Lounge Area</h1>
                </div>
              </div>
            )}

            {building?.amenities?.furnishedRooms && (
              <div className="flex flex-col items-center">
                <div>
                  <Sofa size={24} className="text-gray-400" />
                </div>
                <div>
                  <h1 className="text-sm text-center">Furnished Rooms</h1>
                </div>
              </div>
            )}

            {building?.amenities?.internet && (
              <div className="flex flex-col items-center">
                <div>
                  <Wifi size={24} className="text-gray-400" />
                </div>
                <div>
                  <h1 className="text-sm text-center">Wi-fi</h1>
                </div>
              </div>
            )}

            {building?.amenities?.refrigerator && (
              <div className="flex flex-col items-center">
                <div>
                  <RiFridgeFill size={24} className="text-gray-400" />
                </div>
                <div>
                  <h1 className="text-sm text-center">Refrigerator</h1>
                </div>
              </div>
            )}

            {building?.amenities?.washingMachine && (
              <div className="flex flex-col items-center">
                <div>
                  <GiWashingMachine size={24} className="text-gray-400" />
                </div>
                <div>
                  <h1 className="text-sm text-center">Washing Machine</h1>
                </div>
              </div>
            )}

            {building?.amenities?.bikeParking && (
              <div className="flex flex-col items-center">
                <div>
                  <MdDirectionsBike size={24} className="text-gray-400" />
                </div>
                <div>
                  <h1 className="text-sm text-center">Bike Parking</h1>
                </div>
              </div>
            )}

            {building?.amenities?.carParking && (
              <div className="flex flex-col items-center">
                <div>
                  <IoCarSport size={24} className="text-gray-400" />
                </div>
                <div>
                  <h1 className="text-sm text-center">Car Parking</h1>
                </div>
              </div>
            )}

            <div className="flex flex-col items-center">
              <div>
                <img src={img8} alt="Daily Cleaning" className="h-7 w-7" />
              </div>
              <div>
                <h1 className="text-sm text-center">Daily Cleaning</h1>
              </div>
            </div>

            <div className="flex flex-col items-center">
              <div>
                <img src={img9} alt="Security Deposit" className="h-7 w-7" />
              </div>
              <div>
                <h1 className="text-sm">Security Deposite</h1>
              </div>
            </div>
          </div>
        </div>

        {/* Booking Section */}
        <div
          className="  rounded-lg xl:w-[70%] xl:mx-auto lg:mt-0 mt-5"
          data-aos="zoom-in"
        >
          <div className="flex border rounded-md px-1 py-2 bg-gray-100">
            <button
              onClick={() => setActiveTab("Visit")}
              className={`w-1/2 p-3 text-center font-semibold rounded-full transition-colors ${
                activeTab === "Visit"
                  ? "bg-[#01AECF] text-white"
                  : "bg-transparent text-black"
              }`}
            >
              Schedule A Visit
            </button>
            <button
              onClick={() => setActiveTab("Call")}
              className={`w-1/2 p-3 text-center font-semibold rounded-full transition-colors ${
                activeTab === "Call"
                  ? "bg-[#01AECF] text-white"
                  : "bg-transparent text-black"
              }`}
            >
              Book A Call
            </button>
          </div>

          {/* Form */}
          <div
            className=" p-6  rounded-3xl  border-[#235784] mt-5 border"
            style={{ backgroundImage: `url(${img10})` }}
          >
            <input
              type="text"
              placeholder="Name"
              className="w-full p-3 mb-3 border rounded"
              value={form.name}
              onChange={(e) =>
                setForm({
                  ...form,
                  name: e.target.value,
                })
              }
            />
            <input
              type="text"
              placeholder="+91 | Mobile Number"
              className="w-full p-3 mb-3 border rounded"
              value={form.phone}
              onChange={(e) =>
                setForm({
                  ...form,
                  phone: e.target.value,
                })
              }
            />
            <input
              type="location"
              placeholder="Location"
              className="w-full p-3 mb-3 border rounded"
              value={form.location}
              onChange={(e) =>
                setForm({
                  ...form,
                  location: e.target.value,
                })
              }
            />
            {/* <input type="date" className="w-full p-3 mb-3 border rounded" /> */}

            {/* Terms and Conditions */}
          </div>
          {/* <div className="flex items-start mt-3">
            <input type="checkbox" className="mr-2 mt-1" />
            <p className="text-gray-600 text-sm">
              I have read and agreed to the{" "}
              <a href="#" className="text-blue-600 underline">
                terms and conditions
              </a>{" "}
              and{" "}
              <a href="#" className="text-blue-600 underline">
                privacy policy
              </a>{" "}
              and hereby confirm to proceed.
            </p>
          </div> */}

          {/* Submit Button */}
          <button
            className="w-full bg-[#235784] text-white py-3 mt-4 rounded-lg font-semibold tracking-wide hover:bg-primaryBtnHoverColor"
            onClick={handleSubmit}
          >
            {loading
              ? "Submitting"
              : activeTab === "Visit"
              ? "Schedule a Visit"
              : "Request a callback"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HostelInfo;
